import { render, staticRenderFns } from "./campo.vue?vue&type=template&id=53ac78e3"
import script from "./campo.vue?vue&type=script&lang=ts"
export * from "./campo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports